import { forwardRef, useState, useLayoutEffect, useRef } from 'react';
import { IconNames } from '@shipengine/giger-theme';
import { getOptionTagStyles, getWrapperStyles } from './MultiSelectOptionTagsContainerStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { ContentTag } from '../ContentTag/ContentTag.js';
import { useTruncateOptions } from '../../../hooks/useTruncateOptions/useTruncateOptions.js';

const MultiSelectOptionTagsContainer = /*#__PURE__*/forwardRef((_ref, reference) => {
  let {
    options,
    parentContainer,
    removeTagLabel,
    onTagRemoveClick,
    className
  } = _ref;
  const [htmlOptions, setHtmlOptions] = useState();

  /**
   * First, render options so we can grab the children's width later
   */
  useLayoutEffect(() => {
    const htmlOptions = options.map((option, index) => jsx(ContentTag, {
      value: option.value,
      icon: IconNames.CLOSE,
      iconLabel: `${removeTagLabel} ${option.label}`,
      css: index > 0 && getOptionTagStyles,
      onIconClick: onTagRemoveClick,
      children: option.label
    }, option.value));
    setHtmlOptions(htmlOptions);
  }, [onTagRemoveClick, options, removeTagLabel]);
  const tagContainerRef = useRef(null);
  const {
    optionsToRender,
    optionsToShowAsNumber
  } = useTruncateOptions({
    parentContainer,
    htmlOptions,
    optionsContainer: tagContainerRef.current
  });
  return jsxs("div", {
    ref: reference,
    css: getWrapperStyles,
    className: className,
    children: [jsx("div", {
      ref: tagContainerRef,
      children: optionsToRender || htmlOptions
    }), optionsToShowAsNumber > 0 && jsx(ContentTag, {
      css: getOptionTagStyles,
      children: `+${optionsToShowAsNumber}`
    }, "tagNumber")]
  });
});
MultiSelectOptionTagsContainer.displayName = 'MultiSelectOptionTagsContainer';

export { MultiSelectOptionTagsContainer };
//# sourceMappingURL=MultiSelectOptionTagsContainer.js.map
